


























































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import * as _ from "lodash";
import detect from "@/plugins/browser-detect.ts";
import {
  GetProjectDetail,
  GetGroups,
  PostImportPatientFromHdr,
  PostImportPatientFromCdr,
  PostFetchPatients
} from "@/request/projects";
import { GetPatientsList as ZwbGetPatientList } from "@/request/hdr";
import { GetPatientsList as LcksMzyGetPatientList } from "@/request/cdr";
import { PostImportHospatients } from "@/request/groups";
import Pagination from "@/components/paginaiton.vue";
import Copy from "@/components/copy.vue";
import Header from "../../../components/project-detail-header.vue";
import LeftNav from "../../../components/project-detail-left-nav.vue";
import ProjectSetting from "../../components/project-setting/project-setting.vue";
import Filters from "./filter.vue";
import ChooseGroup from "./choose-group.vue";
@Component({
  components: {
    Header,
    LeftNav,
    ProjectSetting,
    Filters,
    Copy,
    Pagination,
    ChooseGroup
  }
})
export default class ProjectReasearchListImportPatient extends Vue {
  private detect: any;
  private project: any = {
    project_id: ""
  };
  private center: any = {
    id: "",
    name: ""
  };
  private groups: any[] = [];
  private groupId: any = "";
  private filters: any = {
    范围: []
  };
  private count: any = 0;
  // 搜索
  private saveModel: "add" | "delete" = "add";
  // 排序
  private cSortField: string = "创建时间";
  private cSortValue: string = "1";
  // 选择
  private isIndeterminate: boolean = false;
  private checkAll: boolean = false;
  private selectedMessages: any[] = [];
  // 翻页
  private ifLoading: boolean = false;
  private currentPage: any = 1;
  private totalPage: any = 0;
  private totalCount: any = 0;
  private pageSize: any = 10;
  // 列表
  private patients: any[] = [];
  // 项目设置
  private ifShowSet: boolean = false;
  // 高级筛选弹窗
  private ifShowPrimaryFilter: boolean = false;
  private ifPrimarySearched: boolean = false;
  // 选择分组
  private ifShowChooseGroup: boolean = false;

  @Watch("$route.query", { immediate: true })
  private queryChange(id) {
    this.project.project_id = this.$route.query.project_id;
    this.center.id = this.$route.query.center_id;
    this.center.name = this.$route.query.center_name;
    this.center.src_project_id = this.$route.query.src_project_id;
    this.resetFilters();
    this.fetchProjectDetail();
    this.fetchGroups();
    this.fetchPatients();
  }
  /**
   * @description 获得项目详情
   */
  private fetchProjectDetail() {
    GetProjectDetail(this, this.project.project_id).then((data: any) => {
      this.project = data;
    });
  }
  /**
   * @description 获得可以导入的所有分组
   */
  private fetchGroups() {
    GetGroups(this, this.project.project_id).then((data: any) => {
      this.groups = data;
    });
  }
  /**
   * @description 获取患者
   */
  private fetchPatients() {
    this.ifLoading = true;
    this.filters.hospital_ids = [];
    switch (this.center.id) {
      case "治未病数据中心":
        this.filters["范围"].forEach((item: any) => {
          this.filters.hospital_ids.push(item);
        });
        if (this.filters.hospital_ids.includes("")) {
          this.filters.hospital_ids = [];
        }
        const params: any = {
          center: "治未病数据中心",
          hospital_ids: this.filters.hospital_ids,
          order_field: this.cSortField,
          order_value: this.cSortValue,
          current_page: this.currentPage,
          page_count: this.pageSize,
          姓名: this.filters["姓名"],
          性别: this.filters["性别"],
          年龄段: this.filters["年龄段"],
          体重: this.filters["体重"],
          单位: this.filters["单位"],
          老年人体质类型: this.filters["老年人体质类型"],
          儿童体质类型: this.filters["儿童体质类型"],
          体质辨识: this.filters["体质辨识"],
          四诊合参体质辨识: this.filters["四诊合参体质辨识"],
          备孕女性体质辨识: this.filters["备孕女性体质辨识"],
          孕期女性体质辨识: this.filters["孕期女性体质辨识"],
          产后女性体质辨识: this.filters["产后女性体质辨识"],
          慢性病: this.filters["慢性病"]
        };
        // 时间段
        if (this.filters["自定义时间段"][0]) {
          params.params["开始时间"] = this.filters["自定义时间段"][1][0];
          params.params["结束时间"] = this.filters["自定义时间段"][1][1];
        }
        ZwbGetPatientList(this, params)
          .then((data: any) => {
            this.patients = data.patients;
            this.totalPage = data.total_page;
            this.filters.project_id = data.project_id;
            this.filters.group_id = data.group_id;
            this.totalCount = data.total_count;
            if (this.saveModel === "add") {
              this.checkAllMessages(false);
              this.autoCheckSelectedMessages(true);
            } else {
              this.checkAllMessages(true);
              this.autoCheckSelectedMessages(false);
            }
            const checkedCount = this.countHowMuchCurrentPageMessagesSelected();
            this.checkAll = checkedCount === this.patients.length;
            this.isIndeterminate =
              checkedCount > 0 && checkedCount < this.patients.length;
          })
          .finally(() => {
            this.ifLoading = false;
          });
        break;
      case "中医影像数据中心":
        this.filters["范围"].forEach((item: any) => {
          this.filters.hospital_ids.push(item);
        });
        if (this.filters.hospital_ids.includes("")) {
          this.filters.hospital_ids = [];
        }
        const params2: any = {
          center: this.center.id,
          hospital_ids: this.filters.hospital_ids,
          project_id: this.project.project_id,
          group_id: this.filters.group_id,
          order_field: this.cSortField,
          order_value: this.cSortValue,
          current_page: this.currentPage,
          page_count: this.pageSize,
          姓名: this.filters["姓名"],
          性别: this.filters["性别"],
          条件: this.filters["条件"]
        };
        // 时间段
        if (this.filters.timeWay === "自定义") {
          params2["开始时间"] = this.filters.time[0];
          params2["结束时间"] = this.filters.time[1];
          this.ifPrimarySearched = true;
        }
        if (this.filters["研究指标"].length > 0) {
          this.ifPrimarySearched = true;
          const arr: any[] = [];
          this.filters["研究指标"].map((item: any) => {
            const i = JSON.parse(JSON.stringify(item.selected));
            i.condition = item.result.condition;
            i.value = item.result.value;
            arr.push(i);
          });
          params2["研究指标"] = arr;
        }
        ZwbGetPatientList(this, params2)
          .then((data: any) => {
            this.patients = data.patients;
            this.totalPage = data.total_page;
            this.filters.project_id = data.project_id;
            this.filters.group_id = data.group_id;
            this.totalCount = data.total_count;
            if (this.saveModel === "add") {
              this.checkAllMessages(false);
              this.autoCheckSelectedMessages(true);
            } else {
              this.checkAllMessages(true);
              this.autoCheckSelectedMessages(false);
            }
            const checkedCount = this.countHowMuchCurrentPageMessagesSelected();
            this.checkAll = checkedCount === this.patients.length;
            this.isIndeterminate =
              checkedCount > 0 && checkedCount < this.patients.length;
          })
          .finally(() => {
            this.ifLoading = false;
          });
        break;
      case "临床科室数据中心":
      case "名中医传承数据中心":
        this.filters["范围"].forEach((item: any) => {
          this.filters.hospital_ids.push(item);
        });
        if (this.filters.hospital_ids.includes("")) {
          this.filters.hospital_ids = [];
        }
        const params3: any = {
          project_id: this.center.src_project_id,
          hospital_ids: this.filters.hospital_ids,
          group_id: this.filters.group_id,
          order_field: this.cSortField,
          order_value: this.cSortValue,
          current_page: this.currentPage,
          page_count: this.pageSize,
          search: this.filters.search,
          性别: this.filters["性别"],
          条件: this.filters["条件"]
        };
        if (this.filters.timeWay === "自定义") {
          params3["开始时间"] = this.filters.time[0];
          params3["结束时间"] = this.filters.time[1];
          this.ifPrimarySearched = true;
        }
        if (this.filters["研究指标"].length > 0) {
          this.ifPrimarySearched = true;
          const arr: any[] = [];
          this.filters["研究指标"].map((item: any) => {
            const i = JSON.parse(JSON.stringify(item.selected));
            i.condition = item.result.condition;
            i.value = item.result.value;
            arr.push(i);
          });
          params3["研究指标"] = arr;
        }
        LcksMzyGetPatientList(this, params3)
          .then((data: any) => {
            this.patients = data.patients;
            // this.groupId = data.group_id;
            this.filters.project_id = data.project_id;
            this.filters.group_id = data.group_id;
            this.totalPage = data.total_page;
            this.totalCount = data.total_count;
            this.ifShowPrimaryFilter = false;
            if (this.saveModel === "add") {
              this.checkAllMessages(false);
              this.autoCheckSelectedMessages(true);
            } else {
              this.checkAllMessages(true);
              this.autoCheckSelectedMessages(false);
            }
            const checkedCount = this.countHowMuchCurrentPageMessagesSelected();
            this.checkAll = checkedCount === this.patients.length;
            this.isIndeterminate =
              checkedCount > 0 && checkedCount < this.patients.length;
          })
          .finally(() => {
            this.ifLoading = false;
          });
        break;
    }
  }
  /**
   * @description 搜索
   */
  private search() {
    this.currentPage = 1;
    this.saveModel = "delete";
    this.fetchPatients();
  }
  /**
   * @description 处理高级筛选
   */
  private primaryFilterChange(val) {
    this.ifShowPrimaryFilter = false;
    this.$set(this, "filters", val);
    this.currentPage = 1;
    this.saveModel = "delete";
    this.ifPrimarySearched = true;
    this.fetchPatients();
  }
  /**
   * @description 重置filters
   */
  private resetFilters() {
    switch (this.center.id) {
      case "治未病数据中心":
        this.$set(this, "filters", {
          hospital_ids: [],
          范围: [],
          姓名: "",
          性别: "",
          开始年龄: "",
          结束年龄: "",
          开始时间: "",
          结束时间: "",
          年龄段: [],
          自定义年龄: [false],
          体重: [],
          单位: "",
          备孕女性体质辨识: [],
          孕期女性体质辨识: [],
          产后女性体质辨识: [],
          老年人体质类型: [],
          儿童体质类型: [],
          体质辨识: [],
          四诊合参体质辨识: [],
          慢性病: [],
          时间段: "",
          自定义时间段: [false, []]
        });
        break;
      case "中医影像数据中心":
        this.$set(this, "filters", {
          hospital_ids: [],
          范围: [],
          姓名: "",
          性别: "",
          开始时间: "",
          结束时间: "",
          年龄段: [],
          timeWay: "",
          time: [],
          条件: "",
          研究指标: [],
          自定义年龄: [false],
          时间段: "",
          自定义时间段: [false, []]
        });
        break;
      case "名中医传承数据中心":
      case "临床科室数据中心":
        this.$set(this, "filters", {
          hospital_ids: [],
          范围: [],
          search: "",
          性别: "",
          开始时间: "",
          结束时间: "",
          年龄段: [],
          timeWay: "",
          time: [],
          条件: "",
          研究指标: [],
          自定义年龄: [false],
          时间段: "",
          自定义时间段: [false, []]
        });
        break;
    }
  }
  /**
   * @description 重置高级筛选条件
   */
  private resetPrimarySearch() {
    this.ifPrimarySearched = false;
    this.currentPage = 1;
    this.resetFilters();
    this.saveModel = "add";
    this.fetchPatients();
  }
  /**
   * @description 处理翻页器的当前页变化
   */
  private handleCurrentPageChange(val) {
    this.currentPage = val;
    this.fetchPatients();
  }
  /**
   * @description 处理排序变化
   */
  private handleSortChange(ev: any) {
    this.cSortField = ev["prop"];
    this.cSortValue = ev["order"] === "ascending" ? "1" : "0";
    this.fetchPatients();
  }
  // 勾选
  /**
   * @description 给所有message勾选上
   */
  private checkAllMessages(isChecked: boolean) {
    this.patients.forEach((message: any, index: number) => {
      this.$set(this.patients[index], "isChecked", isChecked);
    });
    this.isIndeterminate = false;
    this.checkAll = isChecked ? true : false;
  }
  /**
   * @description 增加一个数据到已选列表
   */
  private addOneMessageToSelectedMessages(message: any) {
    this.selectedMessages.push(message);
    this.selectedMessages = _.uniq(this.selectedMessages);
  }
  /**
   * @description 从已选列表中删除一条数据
   */
  private deleteOneMessageFromSelectedMessages(message: any) {
    const index = this.selectedMessages.findIndex(
      (selectedMessage: any) =>
        selectedMessage.patient_id === message.patient_id
    );
    if (index !== -1) {
      this.selectedMessages.splice(index, 1);
    }
  }
  /**
   * @description 增加当前页面所有的消息进入已选列表
   */
  private addAllMessagesToSelectedMessages() {
    this.patients.forEach((message: any) => {
      this.selectedMessages.push(message);
    });
    this.selectedMessages = _.uniq(this.selectedMessages);
  }
  /**
   * @description 将当前页面的所有数据，从已选列表中删除
   */
  private deleteAllMessagesFromSelectedMessages() {
    this.patients.forEach((message: any) => {
      const targetIndex = this.selectedMessages.findIndex(
        (selectedMessage: any) =>
          selectedMessage.patient_id === message.patient_id
      );
      if (targetIndex !== -1) {
        this.selectedMessages.splice(targetIndex, 1);
      }
    });
  }
  /**
   * @description 统计当前页面有多少数据被选中
   */
  private countHowMuchCurrentPageMessagesSelected() {
    let checkedCount = 0;
    this.patients.forEach((message: any) => {
      if (message.isChecked) {
        checkedCount++;
      }
    });
    return checkedCount;
  }
  /**
   * @description 翻页后自动勾选上已经选择的数据
   */
  private autoCheckSelectedMessages(isChecked: boolean) {
    this.patients.forEach((message: any) => {
      const targetIndex = this.selectedMessages.findIndex(
        (selectedMessage: any) =>
          selectedMessage.patient_id === message.patient_id
      );
      if (targetIndex !== -1) {
        message.isChecked = isChecked;
      }
    });
  }
  /**
   * @description 处理点击全选
   */
  private handleCheckAllChange(val) {
    if (val) {
      this.checkAllMessages(true);
      if (this.saveModel === "add") {
        this.addAllMessagesToSelectedMessages();
      } else if (this.saveModel === "delete") {
        this.deleteAllMessagesFromSelectedMessages();
      }
    } else {
      this.checkAllMessages(false);
      if (this.saveModel === "add") {
        this.deleteAllMessagesFromSelectedMessages();
      } else if (this.saveModel === "delete") {
        this.addAllMessagesToSelectedMessages();
      }
    }
  }
  /**
   * @description 处理单个勾选
   */
  private handleCheckedMessageChange(val, item) {
    if (val) {
      if (this.saveModel === "add") {
        this.addOneMessageToSelectedMessages(item);
      } else if (this.saveModel === "delete") {
        this.deleteOneMessageFromSelectedMessages(item);
      }
    } else {
      if (this.saveModel === "add") {
        this.deleteOneMessageFromSelectedMessages(item);
      } else if (this.saveModel === "delete") {
        this.addOneMessageToSelectedMessages(item);
      }
    }
    const checkedCount = this.countHowMuchCurrentPageMessagesSelected();
    this.checkAll = checkedCount === this.patients.length;
    this.isIndeterminate =
      checkedCount > 0 && checkedCount < this.patients.length;
  }
  /**
   * @description 开始选择分组
   */
  private startChooseGroup() {
    this.ifShowChooseGroup = true;
  }
  /**
   * @description 保存并导入
   */
  private save(groupId) {
    if (!groupId) {
      this.$message.warning("请必须选择一个要导入的分组");
      return;
    }
    this.groupId = groupId;
    const idList: any[] = [];

    const params: any = {
      project_id: this.project.project_id,
      group_id: this.groupId
    };
    const hospitalIds: any[] = [];

    const loading = this.$loading({
      text: "加载中..."
    });
    switch (this.center.id) {
      case "治未病数据中心":
        this.selectedMessages.forEach((message: any) => {
          idList.push(message.hpt_id);
        });
        if (this.saveModel === "add") {
          if (idList.length > 0) {
            params["hpt_ids"] = idList;
          } else {
            this.$message.error("请至少选择一条数据");
            return;
          }
          params["is_use_filter"] = false;
        } else if (this.saveModel === "delete") {
          params["is_use_filter"] = true;
          if (idList.length > 0) {
            params["del_hpt_ids"] = idList;
          }

          this.filters["范围"].forEach((item: any) => {
            hospitalIds.push(item);
          });
        }
        params["src_center"] = "治未病数据中心";
        params["filters"] = {
          hospital_ids: hospitalIds,
          姓名: this.filters["姓名"],
          性别: this.filters["性别"],
          年龄段: this.filters["年龄段"],
          体重: this.filters["体重"],
          单位: this.filters["单位"],
          老年人体质类型: this.filters["老年人体质类型"],
          儿童体质类型: this.filters["儿童体质类型"],
          体质辨识: this.filters["体质辨识"],
          四诊合参体质辨识: this.filters["四诊合参体质辨识"],
          备孕女性体质辨识: this.filters["备孕女性体质辨识"],
          孕期女性体质辨识: this.filters["孕期女性体质辨识"],
          产后女性体质辨识: this.filters["产后女性体质辨识"],
          慢性病: this.filters["慢性病"]
        };
        // 时间段
        if (this.filters["自定义时间段"][0]) {
          params["开始时间"] = this.filters["自定义时间段"][1][0];
          params["结束时间"] = this.filters["自定义时间段"][1][1];
        }
        PostImportPatientFromHdr(this, params)
          .then((data: any) => {
            this.$message.success("导入成功!");
            this.$router.back();
          })
          .finally(() => {
            loading.close();
          });
        break;
      case "中医影像数据中心":
        this.selectedMessages.forEach((message: any) => {
          idList.push(message.hpt_id);
        });
        if (this.saveModel === "add") {
          if (idList.length > 0) {
            params["hpt_ids"] = idList;
          } else {
            this.$message.error("请至少选择一条数据");
            return;
          }
          params["is_use_filter"] = false;
        } else if (this.saveModel === "delete") {
          params["is_use_filter"] = true;
          if (idList.length > 0) {
            params["del_hpt_ids"] = idList;
          }

          this.filters["范围"].forEach((item: any) => {
            hospitalIds.push(item);
          });
        }
        params["src_center"] = this.center.id;
        const filters2: any = {
          hospital_ids: this.filters.hospital_ids,
          project_id: this.filters.project_id,
          group_id: this.filters.group_id,
          姓名: this.filters["姓名"],
          性别: this.filters["性别"],
          条件: this.filters["条件"]
        };
        if (this.filters.timeWay === "自定义") {
          filters2["开始时间"] = this.filters.time[0];
          filters2["结束时间"] = this.filters.time[1];
        }
        if (this.filters["研究指标"].length > 0) {
          const arr: any[] = [];
          this.filters["研究指标"].map((item: any) => {
            const i = JSON.parse(JSON.stringify(item.selected));
            i.condition = item.result.condition;
            i.value = item.result.value;
            arr.push(i);
          });
          filters2["研究指标"] = arr;
        }
        params["filters"] = filters2;
        PostImportPatientFromHdr(this, params)
          .then((data: any) => {
            this.$message.success("导入成功!");
            this.$router.back();
          })
          .finally(() => {
            loading.close();
          });
        break;
      case "临床科室数据中心":
      case "名中医传承数据中心":
        this.selectedMessages.forEach((message: any) => {
          idList.push(message.gropatient_id);
        });
        if (this.saveModel === "add") {
          if (idList.length > 0) {
            params["gropatient_ids"] = idList;
          } else {
            this.$message.error("请至少选择一条数据");
            return;
          }
          params["is_use_filter"] = false;
        } else if (this.saveModel === "delete") {
          params["is_use_filter"] = true;
          if (idList.length > 0) {
            params["del_gropatient_ids"] = idList;
          }

          this.filters["范围"].forEach((item: any) => {
            hospitalIds.push(item);
          });
        }
        params["src_project_id"] = this.center.src_project_id;
        const filters: any = {
          hospital_ids: this.filters.hospital_ids,
          project_id: this.filters.project_id,
          group_id: this.filters.group_id,
          search: this.filters.search,
          条件: this.filters["条件"]
        };
        if (this.filters.timeWay === "自定义") {
          filters["开始时间"] = this.filters.time[0];
          filters["结束时间"] = this.filters.time[1];
        }
        if (this.filters["研究指标"].length > 0) {
          const arr: any[] = [];
          this.filters["研究指标"].map((item: any) => {
            const i = JSON.parse(JSON.stringify(item.selected));
            i.condition = item.result.condition;
            i.value = item.result.value;
            arr.push(i);
          });
          filters["研究指标"] = arr;
        }
        params["filters"] = filters;
        PostImportPatientFromCdr(this, params)
          .then((data: any) => {
            this.$message.success("导入成功!");
            this.$router.back();
          })
          .finally(() => {
            loading.close();
          });
        break;
    }
  }
  private beforeMount() {
    // 兼容性
    this.detect = detect;
    detect.showAgent();
  }
}
